import React from "react"
import CustomImage from "@/main/customImage"
import { Col } from "react-bootstrap"

function Logo(props) {
    return (
        <Col xs={12} sm={6} md={4} xl={2} className="px-3 py-3">
            <div className="logo-image">
                <CustomImage
                    src={`https://webb-jenkins-static-164679926.imgix.net/logos/${props.image}`}
                    alt={props.alt}
                    layout="fill"
                    objectFit="contain"
                    objectPosition="center"
                    sizes="25vw"
                />
            </div>
        </Col>
    )
}

export default Logo
